import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { Pagination } from "@mui/material";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useTranslation } from "react-i18next";
import { DeleteRecentPdfService, RecentPDFService } from "../../../Services/PdfReport";
import { Dialog, DialogTitle, IconButton, DialogContent } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DownloadPdf from "./downolad-pdf";
import { PDFViewer } from "@react-pdf/renderer";
import DocumentPdf from "./document-pdf";

const UrlDev = process.env.REACT_APP_URl;

const GeneratedPdf: React.FunctionComponent<{ change: boolean, onchangeMessageHandler: any }> = (props) => {

    const [listPDF, setListPDF] = useState<any>();
    const [dataLenght, setDataLenght] = useState<any>();
    const [totalPage, setTotalPage] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [PdfId, setPdfId] = useState<any>("");
    const [downloadingPdfs, setDownloadingPdfs] = useState<Set<string>>(new Set());
    const { t } = useTranslation();
    const [isOpenPdf, setIsOpenPdf] = useState<boolean>(false);
    const [PdfValue, setPdfValue] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isPdfLoading, setIsPdfLoading] = useState<boolean>(true);

    const truncateTitle = (title: string, maxLength: number = 30) => {
        if (title.length <= maxLength) return title;
        return title.substring(0, maxLength) + '...';
    };

    useEffect(() => {
        RecentPDFService(pageNumber).then((data) => {
            setIsLoading(false)
            setTotalPage(data.pagination.totalPages);

            // Si la page actuelle est vide et qu'il y a des pages disponibles, rediriger vers la dernière page
            if (data.data.length === 0 && data.pagination.totalPages > 0 && pageNumber > data.pagination.totalPages) {
                setPageNumber(data.pagination.totalPages);
                return;
            }

            setListPDF(data.data);
            setDataLenght(data.data.length);
        }).catch(err => {
            console.log("error");
        });
    }, [pageNumber, isChange, props.change]);



    const handleChangePagination = (event: React.ChangeEvent<unknown>, value: number) => {
        setPageNumber(value);
    };

    const handleDownload = async (pdfId: string) => {
        setDownloadingPdfs(prev => new Set(prev).add(pdfId));
        try {
            const response = await fetch(`${UrlDev}/api/generate-pdf/${pdfId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("usertoken")}`,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const pdfBlob = await response.blob();

            // Find the PDF data to get the title
            const pdfData = listPDF?.find((pdf: any) => pdf._id === pdfId);

            // Get the filename from the Content-Disposition header
            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = `property-${pdfData?.heroSection?.title || 'report'}.pdf`; // Default fallback
            if (contentDisposition) {
                // Extract filename from header (format: attachment; filename="...")
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }
            console.log('Downloading PDF with filename:', filename);
            // Create a download link
            const url = window.URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename; // Use the filename from backend
            // Trigger the download
            document.body.appendChild(link);
            link.click();
            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            console.log('PDF downloaded successfully');

        } catch (error: any) {
            props.onchangeMessageHandler("error", error.response?.data?.message || "Error downloading PDF")
            console.error('Error downloading PDF:', error);
        } finally {
            setDownloadingPdfs(prev => {
                const newSet = new Set(prev);
                newSet.delete(pdfId);
                return newSet;
            });
        }
    };

    const handleDelete = () => {
        DeleteRecentPdfService(PdfId).then((data) => {
            setIsChange(!isChange);
            props.onchangeMessageHandler("success", data.message)
        }).catch(err => {
            props.onchangeMessageHandler("error", err.response.data.message)
        });
    }

    const handleView = (pdf: any) => {
        setIsOpenPdf(true);
        setPdfValue(pdf);
        setIsPdfLoading(true);
        // Hide loader after PDF viewer has had time to render
        setTimeout(() => setIsPdfLoading(false), 3000);
    };

    return (
        <>
            <a className="button-dash color-746AFF text-decoration-underline fw-bold cursor-pointer padd-20" data-bs-toggle="modal" data-bs-target="#viewModal">Generated PDF</a>

            <div className="modal fade" id="viewModal" aria-hidden="true">
                <div className="modal-dialog modal-xl  modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header  mb-4">
                            <h5 className="title-24">Generated PDF</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div className="modal-body">
                            <div className="card border-16">
                                <div className="row padd-24">
                                    {isLoading &&
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div className="spinner-border text-primary size-20" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>}
                                    {dataLenght == 0 ? <h3 className="empty text-center">No PDF available</h3>
                                        : <>
                                            <div className="selected-pdfs mb-4" >
                                                <Swiper
                                                    key={pageNumber}
                                                    observer={true}
                                                    observeParents={true}
                                                    slidesPerView={1}
                                                    spaceBetween={30}
                                                    loop={false}
                                                    navigation={true}
                                                    modules={[Navigation]}
                                                    className="mySwiper"
                                                    breakpoints={{
                                                        320: {
                                                            slidesPerView: 1,
                                                            spaceBetween: 10,
                                                        },
                                                        576: {
                                                            slidesPerView: 2,
                                                            spaceBetween: 15,
                                                        },
                                                        768: {
                                                            slidesPerView: 3,
                                                            spaceBetween: 20,
                                                        },
                                                        992: {
                                                            slidesPerView: 4,
                                                            spaceBetween: 25,
                                                        },
                                                        1200: {
                                                            slidesPerView: 4,
                                                            spaceBetween: 30,
                                                        },
                                                    }} >
                                                    {listPDF?.map((pdf: any, index: number) => (
                                                        <SwiperSlide key={index}>
                                                            <div className="pdf-wrapper">
                                                                <div className="pdf-preview mb-3">
                                                                    <div className="pdf-icon">
                                                                        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16Z" fill="#DC2626" />
                                                                            <path d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z" fill="#DC2626" />
                                                                            <path d="M12 14H10V8H12C12.55 8 13 8.45 13 9V13C13 13.55 12.55 14 12 14ZM11 9V13H12V9H11Z" fill="#DC2626" />
                                                                            <path d="M15 8H17V9H16V10H17V11H16V14H15V8Z" fill="#DC2626" />
                                                                            <path d="M18 8H20V9H19V14H18V8Z" fill="#DC2626" />
                                                                        </svg>
                                                                    </div>
                                                                    <div className="pdf-info">
                                                                        <h6 className="pdf-title" title={pdf.heroSection?.title || `PDF Report ${index + 1}`}>
                                                                            {truncateTitle(pdf.heroSection?.title || `PDF Report ${index + 1}`)}
                                                                        </h6>
                                                                        <p className="pdf-date">{new Date(pdf.createdAt).toLocaleDateString()}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="text-end mt-2">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => setPdfId(pdf._id)}
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#dropModal"
                                                                        className="btn recent-download border-746AFF"
                                                                    >
                                                                        <i className="fa-solid fa-trash" style={{ color: "#716BE3" }}></i>
                                                                    </button>

                                                                    <DownloadPdf
                                                                        PdfValue={pdf}
                                                                        isLoading={downloadingPdfs.has(pdf._id)}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleView(pdf)}
                                                                        className="btn recent-download border-746AFF"
                                                                    >
                                                                        <i className="fa fa-eye" aria-hidden="true" style={{ color: "#716BE3" }}></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Pagination count={totalPage} variant="outlined" shape="rounded" onChange={handleChangePagination} />
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="dropModal" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel1">{t("propertiesPage.confirmation")}</h5>
                        </div>
                        <div className="modal-body">
                            <p>{t("report.msgConfirmationPDF")}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" style={{ float: "right" }} data-bs-dismiss="modal">
                                {t("propertiesPage.no")}
                            </button>
                            <button type="button" data-bs-dismiss="modal" style={{ float: "right" }} className="btn btn-danger" onClick={handleDelete}>
                                {t("propertiesPage.yes")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                fullWidth
                maxWidth="lg"
                open={isOpenPdf}
                onClose={() => setIsOpenPdf(false)}
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle id="customized-dialog-title">
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setIsOpenPdf(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        bgcolor: 'grey.700',
                        color: 'common.white',
                        '&:hover': {
                            bgcolor: 'grey.800',
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    {isPdfLoading && (
                        <div className="back-pdf-overlay">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="color-64748B para-16 mt-3">Preparing your PDF...</p>
                        </div>
                    )}
                    <PDFViewer width="100%" height="auto" style={{ border: 'none', minHeight: '75vh' }} showToolbar={false}>
                        <DocumentPdf propertyReport={PdfValue} />
                    </PDFViewer>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default GeneratedPdf;